module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "elevation-10"
  }, [_c('v-toolbar', {
    attrs: {
      "color": 'primary white--text'
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("\n              Editar Projeto de Pesquisa " + _vm._s(_vm.projetoPesquisa.numRegistro === null || _vm.projetoPesquisa.numRegistro === '' ? '' : 'nº ' + _vm.projetoPesquisa.numRegistro + ' ') + " - " + _vm._s(_vm.projetoPesquisa.titulo) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs', {
    attrs: {
      "slot": "extension",
      "centered": "",
      "show-arrows": "",
      "dark": "",
      "next-icon": "mdi-arrow-right-bold-box-outline",
      "prev-icon": "mdi-arrow-left-bold-box-outline",
      "color": "primary",
      "hide-slider": ""
    },
    slot: "extension"
  }, [_c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaInformacoesBasicas'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Informações Básicas")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaDetalhamento'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Detalhamento")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaInstituicoes'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Instituições")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaEquipe'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Equipe")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaOrgaosFinanciadores'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Órgãos Financiadores")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'ProjetoPesquisaArquivos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Arquivos")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaOutrasInformacoes'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Outras Informações")]), _vm._v(" "), _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaContatos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Contatos")]), _vm._v(" "), (_vm.habilitaAbaResultadosObtidos()) ? _c('router-link', {
    staticClass: "router_disable",
    attrs: {
      "exact": "",
      "to": {
        name: 'EditarProjetoPesquisaResultadosObtidos'
      },
      "tag": "v-tab"
    }
  }, [_vm._v("Resultados Obtidos")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('router-view', {
    attrs: {
      "idProjetoPesquisa": _vm.idProjetoPesquisa,
      "projetoPesquisa": this.projetoPesquisa
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f00684e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pesquisa/editar-projeto-pesquisa.vue
// module id = 887
// module chunks = 0